exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".background-blue{background-color:#2e69c7;color:#fff}.background-green{background-color:#468628;color:#fff}.background-red{background-color:#ce3740;color:#fff}.background-orange{background-color:#cf9e35;color:#fff}.background-yellow{background-color:#ff0;color:#000}.body-blue{background-color:#2e69c7}.body-green{background-color:#468628}.body-red{background-color:#ce3740}.body-orange{background-color:#cf9e35}", ""]);

// exports
